<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-button type="primary" @click="checkNetStatus">检测医保网络</el-button>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="5">
        <el-input placeholder="根据用户手机号查询医保交易记录..." v-model="mobile" size="mini">
          <el-button slot="append" icon="el-icon-search" @click="numberSearch"></el-button>
        </el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="身份证号码..." v-model="idNo" size="mini"></el-input>
      </el-col>
      <el-col :span="3">
        <el-input placeholder="医保卡密码..." v-model="password" size="mini">
          <el-button slot="append" icon="el-icon-search" @click="getMemberInfo"></el-button>
        </el-input>
      </el-col>
    </el-row>
    <div v-if="this.memberInfo.AAC003">
      <el-tabs type="border-card">
        <el-tab-pane label="用户信息"></el-tab-pane>
        <div class="info" label="姓名"><span class="item">姓名：</span>{{this.memberInfo.AAC003}}</div>
        <div class="info" label="身份证号码"><span class="item">身份证号码：</span>{{this.memberInfo.AAC002}}</div>
        <div class="info" label="单位名称"><span class="item">单位名称：</span>{{this.memberInfo.AAB004}}</div>
        <div class="info" label="账户余额"><span class="item">账户余额：</span>{{this.memberInfo.BKC276}}</div>
      </el-tabs>
    </div>
    <div v-else>
      <el-tabs type="border-card">
        <el-tab-pane label="交易记录"></el-tab-pane>
        <el-table :data="list" style="width: 100%" :height="wheight-140">
          <el-table-column label="订单号" min-width="100">
            <template slot-scope="scope">
              <span>{{scope.row.BKC023}}</span>
            </template>
          </el-table-column>
          <el-table-column label="交易流水号" min-width="100">
            <template slot-scope="scope">
              <span>{{scope.row.AKC190}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="mobile" label="用户手机号"></el-table-column> -->
          <el-table-column label="交易金额">
            <template slot-scope="scope">
              <span>{{scope.row.AKC255}}</span>
            </template>
          </el-table-column>
          <el-table-column label="交易时间">
            <template slot-scope="scope">
              <span>{{scope.row.AAE036}}</span>
            </template>
          </el-table-column>
          <el-table-column label="订单来源">
            <template slot-scope="scope">
              <span v-if="scope.row.BKC023.length == 15">商城</span>
              <span v-else>多店铺</span>
            </template>
          </el-table-column>
        </el-table>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getShengyibaoNetStatus, getShengyibaoMemberTrades, getShengyibaoMemberInfo } from '../../../api/trade.js'

export default ({
  data () {
    return {
      idNo: '',
      password: '',
      mobile: '',
      list: [],
      memberInfo: []
    }
  },
  methods: {
    checkNetStatus: function() {
      getShengyibaoNetStatus().then(response => {
        this.$message({
          type: 'success',
          message: '医保网络连接正常，请勿频繁访问~'
        })
      })
    },
    numberSearch: function(e) {
      let query = {
        "mobile": this.mobile
      }
      getShengyibaoMemberTrades(query).then(response => {
        this.memberInfo = []
        this.list = response.data.data.list
      })
    },
    getMemberInfo: function(e) {
      let query = {
        "idNo": this.idNo,
        "password": this.password
      }
      getShengyibaoMemberInfo(query).then(response => {
        this.memberInfo = response.data.data
      })
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  }
})
</script>
<style>
  span.item{
    font-weight: bold;
    min-width: 100px;
    width: 100px;
    display: inline-block;
    letter-spacing: 2px;
  }
  div.info{
    margin: 15px 5px;
    border-bottom: 1px solid #eee;
  }
</style>



// WEBPACK FOOTER //
// shengyibao.vue?1d34e396